export var SkeletonVariant;
(function (SkeletonVariant) {
    SkeletonVariant["Text"] = "text";
    SkeletonVariant["Circle"] = "circle";
    SkeletonVariant["Rect"] = "rect";
})(SkeletonVariant || (SkeletonVariant = {}));
export var SkeletonAnimation;
(function (SkeletonAnimation) {
    SkeletonAnimation["None"] = "none";
    SkeletonAnimation["Pulse"] = "pulse";
    SkeletonAnimation["Wave"] = "wave";
})(SkeletonAnimation || (SkeletonAnimation = {}));
